// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alert-message[data-v-5f7d2547] {\r\n  margin-top: 5px;\n}\n.error-text[data-v-5f7d2547] {\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n  width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
